<script>
    import { user } from './stores/login_store.js'

    import ProgressBar from './sub/ProgressBar.svelte'
    import ListingFile from './sub/ListingFile.svelte'

    let files = null
    let expired_files = null

    const get_listing = async () => {
        let body = await fetch('/api/files/user', {
            credentials: 'include'
        })

        body = await body.json()

        if (body.ok) {
            const current_stamp = new Date().getTime()
            files         = body.files.filter(f => f.expires > current_stamp)
            expired_files = body.files.filter(f => f.expires < current_stamp)
            return true
        } else {
            console.error(body)
            return []
        }
    }
</script>

<style>
    summary {
        cursor: pointer;
    }

    li {
        margin: 1em 0;
    }
</style>

<div class="page_container">
    <h1 class="title">{$user.username}'s files</h1>
    <h2 class="subtitle level">
        <div class="level-left">
            <span>
                {#if files}
                    {files.length} files available.
                {:else}
                    Available files
                {/if}
            </span>
        </div>

        <div class="level-right">
            <a href="/upload">
                <span>Upload</span>
                <span class="icon">
                    <i class="fas fa-arrow-right"></i>
                </span>
            </a>
        </div>
        
        
    </h2>


    {#await get_listing()}
        <ProgressBar/>
    {:then _}
        <h2 class="is-size-3">Active files</h2>
        
        <ul>
        {#if files.length > 0}
            {#each files as file}
                <li>
                    <ListingFile file={file}/>
                </li>
            {/each}
        {:else}
            <li><i>No files to show.</i></li>
        {/if}
        </ul>

        <h2 class="is-size-3">Expired Files</h2>
        <details>
            <summary>Show {expired_files.length} files</summary>
            <ul>
            {#each expired_files as file}
                <li>
                    <ListingFile file={file}/>
                </li>
            {/each}
            </ul>
            
        </details>
    {:catch}
        <p> something went wrong </p>
    {/await}
    
    
</div>
